import React from "react"
import { Column, ColumnSizes } from "../types/bikeFleetType"

export const useColumnSize = <T extends Column>(columns: T[]) => {
	const columnSizes: ColumnSizes = React.useMemo(() => {
		const sizes: ColumnSizes = {}
		columns.forEach((column) => {
			switch (column.accessor) {
				case columns[0].accessor:
					sizes[column.accessor] = "px-4 w-[50px]"
					break
				case columns[1].accessor:
					sizes[column.accessor] = "c-table__cell--5"
					break
				case columns[2].accessor:
				case columns[3].accessor:
				case columns[4].accessor:
				case columns[5].accessor:
				case columns[6].accessor:
				case columns[7].accessor:
					sizes[column.accessor] = "c-table__cell--4"
					break
				case columns[8].accessor:
					sizes[column.accessor] = "c-table__cell--2"
					break
				default:
					sizes[column.accessor] = "flex-initial"
					break
			}
		})
		return sizes
	}, [columns])

	const getColumnSize = React.useCallback(
		(columnName: string) => {
			return columnSizes[columnName] || "flex-initial"
		},
		[columnSizes]
	)

	return getColumnSize
}
